import type { Memo } from "../types";

export function compareMemos(a: Memo, b: Memo): number {
  if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
  if (a.pinned) {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      || a.sort_order - b.sort_order;
  }
  return a.sort_order - b.sort_order;
}

export function nextMemoSortOrder(memos: Memo[]): number {
  const normalOrders = memos.filter((memo) => !memo.pinned).map((memo) => memo.sort_order);
  return normalOrders.length ? Math.min(...normalOrders) - 1 : 0;
}

export function memoDisplayTitle(memo: Pick<Memo, "title" | "body">): string {
  const explicitTitle = memo.title.trim();
  if (explicitTitle) return explicitTitle;
  const firstBodyLine = memo.body
    .split(/\r?\n/)
    .map((line) => line.replace(/^\s*(?:#{1,6}\s+|[-*+]\s+|\d+[.)]\s+|>\s*)/, "").trim())
    .find(Boolean);
  return firstBodyLine?.slice(0, 80) || "無題のメモ";
}
